module.exports = __webpack_public_path__ + "static/media/stars-less-1366.63ad5639.webp";